import { Checkbox } from "@material-tailwind/react";

export function DisabledCheckbox() {
  return <Checkbox label="Remember Me" disabled={true} />;
}
